import React, { useState, useEffect } from "react";
import AdminLayout from "../UI/Layout/AdminLayout";
import Axios from "axios";
import { NODE_HOST_URL_v1 } from "../Dashboard/api/Api";
import { MdSave, MdClose, MdImage, MdOutlineModeEditOutline } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { HiOutlineTrash } from "react-icons/hi";
import { AiOutlineEye } from "react-icons/ai";

// --- Status Badge ---
const StatusBadge = ({ status }) => (
    <span className={`badge rounded-pill fw-bold ${status === 1 ? "bg-green" : "bg-danger"}`}>
        {status === 1 ? "Active" : "Inactive"}
    </span>
);

const AdminIntegrationPanel = () => {

    // ---------------- USER STATE ----------------
    const lStorage =
        JSON.parse(localStorage.getItem("admin")) ||
        JSON.parse(localStorage.getItem("emp")) ||
        JSON.parse(localStorage.getItem("reseller"));

    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const type = lStorage?.user?.isAdmin;

    const [user, setUser] = useState(null);

    useEffect(() => {
        if (lStorage) {
            setUser({ userId, userToken, type });
        }
    }, []);

    // ---------------- FORM STATE ----------------
    const [platformName, setPlatformName] = useState("");
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState("");

    // Add Platform modal visibility
    const [showAddModal, setShowAddModal] = useState(false);

    // Edit state
    const [editingId, setEditingId] = useState(null);
    const [editingName, setEditingName] = useState("");
    const [editingStatus, setEditingStatus] = useState(1);
    const [showEditModal, setShowEditModal] = useState(false);

    const [confirmDelete, setConfirmDelete] = useState({
        show: false,
        id: null,
        name: ""
    });

    const [platformList, setPlatformList] = useState([]);
    const [selectedImage, setSelectedImage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);


    const [error, setError] = useState({
        successMessage: false,
        errorMessage: "",
        bgColor: "alert alert-danger alert-dismissible",
    });

    // auto hide error
    useEffect(() => {
        if (error.errorMessage) {
            const timer = setTimeout(() => {
                setError({ ...error, errorMessage: "" });
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    // ---------------- LOGO UPLOAD ----------------
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        setLogoFile(file);
        if (file) setLogoPreview(URL.createObjectURL(file));
        else setLogoPreview("");
    };

    // ---------------- SUBMIT (CREATE) ----------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!platformName.trim() || !logoFile) {
            return setError({
                successMessage: false,
                errorMessage: "Please fill the platform name and upload a logo.",
                bgColor: "alert alert-danger alert-dismissible",
            });
        }
        const form = e.target;
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("platform_name", platformName);
            formData.append("user_type", user.type);
            formData.append("user_id", user.userId);
            formData.append("token", user.userToken);
            formData.append("method", "InsertPlatform");
            formData.append("logo", logoFile);

            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/DataReceiver`, formData);

            if (data.success) {
                setError({
                    successMessage: true,
                    errorMessage: "Platform created successfully!",
                    bgColor: "alert alert-success alert-dismissible",
                });

                fetchList();
                setShowAddModal(false); // CLOSE MODAL AFTER SUCCESS
            }
            else {
                setError({
                    successMessage: false,
                    errorMessage: data.message || "Platform creation failed.",
                    bgColor: "alert alert-danger alert-dismissible",
                });
            }

            // Reset fields
            setPlatformName("");
            setLogoFile(null);
            setLogoPreview("");

            form.reset()

        } catch (err) {
            console.log(err?.response);

            setError({
                successMessage: false,
                errorMessage: err?.response?.data?.message || "Something went wrong!",
                bgColor: "alert alert-danger alert-dismissible",
            });
        }
        setLoading(false);
    };

    // ---------------- DELETE ----------------
    const deletePlatform = async () => {
        setLoading(true);
        try {
            const body = {
                method: "DeletePlatform",
                user_id: userId,
                token: userToken,
                user_type: type,
                id: confirmDelete.id,
                platform_name: confirmDelete.name
            };

            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/DataReceiver`, body);

            if (data.success) {
                setError({
                    successMessage: true,
                    errorMessage: "Platform deleted successfully!",
                    bgColor: "alert alert-success alert-dismissible"
                });

                setPlatformList(prev => prev.filter(item => item.id !== confirmDelete.id));
            } else {
                setError({
                    successMessage: false,
                    errorMessage: data.message || "Deletion failed.",
                    bgColor: "alert alert-danger alert-dismissible"
                });
            }

        } catch (error) {
            setError({
                successMessage: false,
                errorMessage: error?.response?.data?.message || "Delete failed!",
                bgColor: "alert alert-danger alert-dismissible"
            });
        }

        setConfirmDelete({ show: false, id: null, name: "" });
        setLoading(false);
    };

    // ---------------- UPDATE ----------------
    const updatePlatformName = async (id) => {
        if (!editingName.trim()) return alert("Platform name cannot be empty");
        setLoading(true);
        try {
            const body = {
                method: "EditPlatform",
                user_id: userId,
                token: userToken,
                user_type: type,
                id,
                platform_name: editingName,
                status: editingStatus
            };

            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/DataReceiver`, body);

            if (data.success) {
                setError({
                    successMessage: true,
                    errorMessage: "Platform updated successfully!",
                    bgColor: "alert alert-success alert-dismissible"
                });

                setPlatformList(prev =>
                    prev.map(item =>
                        item.id === id ? { ...item, plat_name: editingName, status: editingStatus } : item
                    )
                );

                setEditingId(null);
            } else {
                setError({
                    successMessage: false,
                    errorMessage: data.message || "Update failed.",
                    bgColor: "alert alert-danger alert-dismissible"
                });
            }

        } catch (error) {
            setError({
                successMessage: false,
                errorMessage: error?.response?.data?.message || "Update failed!",
                bgColor: "alert alert-danger alert-dismissible"
            });
        }
        setLoading(false);
    };

    // ---------------- FETCH LIST ----------------
    const fetchList = async () => {
        setLoading(true);
        try {
            const body = {
                method: "ListPlatform",
                user_id: userId,
                user_type: type,
                token: userToken,
            };

            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/DataReceiver`, body);

            if (data.success && Array.isArray(data.data)) {
                setPlatformList(data.data);
            }else{
                 setError({
                    successMessage: false,
                    errorMessage: data.message || "Failed to fetch list",
                    bgColor: "alert alert-danger alert-dismissible",
                });
            }
        } catch (error) {
            setError({
                successMessage: false,
                errorMessage: error?.response?.data?.message || "Something went wrong, please try again later.",
                bgColor: "alert alert-danger alert-dismissible"
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (userId) fetchList();
    }, [userId]);

    // ---------------------------------------------------------------------
    //                              UI START
    // ---------------------------------------------------------------------

    return (
        <AdminLayout>

            <div className="container-fluid p-0">

                {/* PAGE TITLE */}
                <div className="row mb-3">
                    <div className="col-12 d-flex justify-content-between align-items-center">
                        <h4 className="fw-bold mb-0">Platform Integrations</h4>

                        {/* NEW BUTTON (opens modal) */}
                        <button className="btn btn-primary" onClick={() => setShowAddModal(true)}>
                            Add Platform
                        </button>
                    </div>
                </div>

                {/* ALERTS */}
                {error.errorMessage && (
                    <div className={`d-flex align-items-center ${error.bgColor}`} role="alert">
                        <button
                            type="button"
                            onClick={() => setError({ ...error, errorMessage: "" })}
                            className="border-0 bg-transparent p-1 d-flex align-items-center justify-content-center"
                            style={{
                                height: "32px",
                                width: "32px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                transition: "0.2s",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f1f1")}
                            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                            <IoMdClose size={20} />
                        </button>
                        {error.errorMessage}
                    </div>
                )}

                {/* LIST CARD */}
                <div className="card shadow-sm mb-0" >
                    <div className="card-body">

                        <h3 className="h5 fw-bold mb-3">
                            Existing Integrations ({platformList.length})
                        </h3>

                        {/* Scrollable table area */}
                        <div
                            className="table-responsive"
                            style={{
                                maxHeight: "70vh",
                                overflowY: "auto",
                                overflowX: "auto",
                            }}
                        >
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Logo</th>
                                        <th>Platform Name</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading && (
                                        <tr>
                                            <td colSpan="4" className="text-center py-5">
                                                <div className="d-flex flex-column align-items-center">
                                                    <div className="spinner-border text-primary mb-2" role="status"></div>
                                                    <span className="text-muted">Loading platforms...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                    {!loading && platformList.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted py-4">
                                                No platforms found.
                                            </td>
                                        </tr>
                                    )}
                                    {!loading && (
                                        platformList.map((item) => (
                                            <tr
                                                key={item.id}
                                                className={editingId === item.id ? "table-light" : ""}
                                            >
                                                {/* Logo */}
                                                <td>
                                                    <div
                                                        className="border rounded p-1"
                                                        style={{
                                                            height: "40px",
                                                            width: "40px",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                        onClick={() => {
                                                            setSelectedImage(item.plat_logo);
                                                            setShowModal(true);
                                                        }}
                                                    >
                                                        <img
                                                            src={item.plat_logo}
                                                            alt={item.plat_name}
                                                            style={{
                                                                objectFit: "contain",
                                                                maxWidth: "100%",
                                                                maxHeight: "100%",
                                                            }}
                                                        />
                                                    </div>
                                                </td>

                                                {/* Name */}
                                                <td>
                                                    <span className="fw-bold">{item.plat_name}</span>
                                                </td>

                                                {/* Status */}
                                                <td>
                                                    <StatusBadge status={item.status} />
                                                </td>

                                                {/* Actions */}
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-dark me-2"
                                                        onClick={() => {
                                                            setSelectedImage(item.plat_logo);
                                                            setShowModal(true);
                                                        }}
                                                    >
                                                        <AiOutlineEye /> Preview
                                                    </button>

                                                    <button
                                                        className="btn btn-sm btn-outline-primary me-2"
                                                        onClick={() => {
                                                            setEditingId(item.id);
                                                            setEditingName(item.plat_name);
                                                            setEditingStatus(item.status);
                                                            setShowEditModal(true);
                                                        }}
                                                    >
                                                        <MdOutlineModeEditOutline /> Edit
                                                    </button>

                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() =>
                                                            setConfirmDelete({
                                                                show: true,
                                                                id: item.id,
                                                                name: item.plat_name,
                                                            })
                                                        }
                                                    >
                                                        <HiOutlineTrash />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            {/* --------------------------------------------------------------------
                   ADD PLATFORM MODAL
                -------------------------------------------------------------------- */}
            {showAddModal && (
                <div className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
                    onClick={() => setShowAddModal(false)}
                >
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content" style={{ borderRadius: "8px" }}>

                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">Add New Platform</h5>
                                <button
                                    type="button"
                                    onClick={() => setShowAddModal(false)}
                                    className="border-0 bg-transparent p-1 d-flex align-items-center justify-content-center"
                                    style={{
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f1f1")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                >
                                    <IoMdClose size={20} />
                                </button>

                            </div>

                            <div className="modal-body">

                                <form onSubmit={handleSubmit}>

                                    {/* Logo Preview */}
                                    <div className="d-flex justify-content-center mb-3">
                                        <div className="p-2 border rounded"
                                            style={{
                                                height: "70px",
                                                width: "70px",
                                                overflow: "hidden",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                            {logoPreview ? (
                                                <img src={logoPreview} className="img-fluid" style={{ objectFit: "contain" }} />
                                            ) : (
                                                <MdImage size={35} className="text-muted" />
                                            )}
                                        </div>
                                    </div>

                                    {/* Platform Name */}
                                    <div className="mb-3">
                                        <label className="form-label">Platform Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={platformName}
                                            onChange={(e) => setPlatformName(e.target.value)}
                                        />
                                    </div>

                                    {/* Upload */}
                                    <div className="mb-3">
                                        <label className="form-label">Upload Logo</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleLogoUpload}
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                                        {loading ? (
                                            <div className="spinner-border spinner-border-sm me-2"></div>
                                        ) : null}
                                        {loading ? "Please wait..." : "Create Platform"}
                                    </button>


                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* --------------------------------------------------------------------
                   EDIT PLATFORM MODAL
                -------------------------------------------------------------------- */}
            {showEditModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
                    onClick={() => {
                        setShowEditModal(false);
                        setEditingId(null);
                    }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ borderRadius: "10px" }}>

                            {/* Header */}
                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fw-semibold">Edit Platform</h5>

                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowEditModal(false);
                                        setEditingId(null);
                                    }}
                                    className="border-0 bg-transparent p-1 d-flex align-items-center justify-content-center"
                                    style={{
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: ".2s",
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.background = "#f1f1f1")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.background = "transparent")
                                    }
                                >
                                    <IoMdClose size={20} />
                                </button>
                            </div>

                            {/* Body */}
                            <div className="modal-body">

                                {/* Platform Name */}
                                <div className="mb-3">
                                    <label className="form-label fw-medium">Platform Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={editingName}
                                        onChange={(e) => setEditingName(e.target.value)}
                                    />
                                </div>

                                {/* Status */}
                                <div className="mb-3">
                                    <label className="form-label fw-medium">Status</label>
                                    <select
                                        className="form-select"
                                        value={editingStatus}
                                        onChange={(e) => setEditingStatus(Number(e.target.value))}
                                    >
                                        <option value={1}>Active</option>
                                        <option value={2}>Inactive</option>
                                    </select>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="modal-footer border-0 d-flex justify-content-end">
                                <button
                                    className="btn btn-light px-4"
                                    onClick={() => {
                                        setShowEditModal(false);
                                        setEditingId(null);
                                    }}
                                    style={{ borderRadius: "6px" }}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-primary px-4"
                                    disabled={loading}
                                    onClick={() => {
                                        updatePlatformName(editingId);
                                        setShowEditModal(false);
                                    }}
                                    style={{ borderRadius: "6px" }}
                                >
                                    {loading && (
                                        <div className="spinner-border spinner-border-sm me-2"></div>
                                    )}
                                    {loading ? "Saving..." : "Save"}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* IMAGE PREVIEW MODAL */}
            {showModal && (
                <div className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
                    onClick={() => setShowModal(false)}
                >
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Logo Preview</h5>
                                <button
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                    className="border-0 bg-transparent p-1 d-flex align-items-center justify-content-center"
                                    style={{
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f1f1")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                >
                                    <IoMdClose size={20} />
                                </button>

                            </div>
                            <div className="modal-body text-center">
                                <img src={selectedImage} className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* DELETE CONFIRM MODAL */}
            {confirmDelete.show && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.6)" }}
                    onClick={() => setConfirmDelete({ show: false })}
                >
                    <div
                        className="modal-dialog modal-sm modal-dialog-centered"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content" style={{ borderRadius: "10px" }}>

                            {/* Header */}
                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fw-semibold">Confirm Deletion</h5>

                                {/* Modern Close Button */}
                                <button
                                    type="button"
                                    onClick={() => setConfirmDelete({ show: false })}
                                    className="border-0 bg-transparent p-1 d-flex align-items-center justify-content-center"
                                    style={{
                                        height: "32px",
                                        width: "32px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        transition: ".2s",
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.background = "#f1f1f1")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.background = "transparent")
                                    }
                                >
                                    <IoMdClose size={20} />
                                </button>
                            </div>

                            {/* Body */}
                            <div className="modal-body text-center pt-2 pb-2">
                                <p className="mb-1 fw-medium">
                                    Are you sure you want to delete:
                                </p>

                                <p className="fw-semibold mb-0" style={{ fontSize: "15px" }}>
                                    {confirmDelete.name}
                                </p>

                                <p className="text-muted small mt-2 mb-0">
                                    This action cannot be undone.
                                </p>
                            </div>

                            {/* Footer */}
                            <div className="modal-footer border-0 d-flex justify-content-center pt-0">
                                <button
                                    className="btn btn-light px-4"
                                    onClick={() => setConfirmDelete({ show: false })}
                                    style={{ borderRadius: "6px" }}
                                >
                                    Cancel
                                </button>

                                <button
                                    className="btn btn-danger px-4"
                                    disabled={loading}
                                    onClick={deletePlatform}
                                    style={{ borderRadius: "6px" }}
                                >
                                    <HiOutlineTrash className="me-1" /> Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </AdminLayout>
    );
};

export default AdminIntegrationPanel;
